/**
 * Service-worker registration helper. Quiet on dev (localhost), live in prod.
 * Listens for SW updates and broadcasts a custom event so the UI can prompt
 * the user to reload.
 */
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Skip on localhost dev — CRA's craco devServer already serves fresh assets
  // and an SW would just confuse hot-reload.
  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname.endsWith(".local");
  if (isLocalhost) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        // Listen for new versions arriving in the background
        reg.addEventListener("updatefound", () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              window.dispatchEvent(new CustomEvent("pwa:update-available"));
            }
          });
        });
      })
      .catch(() => {
        // Quietly swallow — SW is a nice-to-have, never block the app
      });
  });
}
